export const currency = (value: number) => {
  let AEDFormat = new Intl.NumberFormat('en-AE', {
    style: 'currency',
    currency: 'AED',
  })

  return AEDFormat.format(value)
}

export const digit = (value: number) => {
  let AEDFormat = new Intl.NumberFormat('en-AE', {
    style: 'decimal',
  })

  return AEDFormat.format(value)
}
